import getters from '@/store/modules/board/getters';
import mutations from '@/store/modules/board/mutations';
import actions from '@/store/modules/board/actions';

export const state = {
  reqPageInfo: {
    page: 1,
    limit: 12
  },
  pageInfo: {
    page: 1,
    pageBlock: '',
    rowPerPage: '',
    pagePerBlock: '',
    totalRow: '',
    virtualNum: '',
    totalPage: 2,
    totalBlock: '',
    startPage: '',
    endPage: '',
    isPrevBlock: '',
    isNextBlock: '',
    startIdx: '',
    boardType: ''
  },
  boardInfo: {
    boardNo: '',
    title: '',
    content: '',
    boardType: '',
    regDate: '',
    uptDate: '',
    toggleState: false
  },
  alarmInfo: {},
  alarmList: [],
  boardList: [],
  faqList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
